export default __webpack_public_path__ + "static/media/warloc_vector2.537c4315.svg";